<div id="evaluation-container" class="container" *ngIf="dataLoaded === true">

    <div class="no-class-title" *ngIf="sessions.length == 0">
        <h2>Aucune évaluation enregistrée</h2>
    </div>


    <div *ngIf="sessions.length > 0">

        <!-- Chart -->

        <div class="row">
            <div class="col-md-12">
                <div style="display: block;">
                    <canvas baseChart width="600" height="200"
                            [datasets]="this.chartData.lineChartData"
                            [labels]="this.chartData.lineChartLabels"
                            [options]="this.chartData.lineChartOptions"
                            [colors]="this.chartData.lineChartColors"
                            [legend]="this.chartData.lineChartLegend"
                            [chartType]="this.chartData.lineChartType"
                            (chartHover)="chartHovered($event)"
                            (chartClick)="chartClicked($event)">
                    </canvas>
                </div>
            </div>
        </div>



        <!-- Scores -->

        <div class="row" style="text-align: center; padding-top: 25px">
            <div class="col-sm-3">
                Connaissance du sujet: <b>{{trainerScoresAverage['trainerSubjectKnowledge']}}</b>
            </div>
            <div class="col-sm-3">
                Qualités pédagogiques: <b>{{trainerScoresAverage['trainerPedagogicalQuality']}}</b>
            </div>
            <div class="col-sm-3">
                Qualité de ses réponses: <b>{{trainerScoresAverage['trainerAnswerQuality']}}</b>
            </div>
            <div class="col-sm-3">
                Disponibilité: <b>{{trainerScoresAverage['trainerAvailability']}}</b>
            </div>
        </div>

        <!-- Liste des sessions -->


        <div class="col-xs-12 table-responsive list-sessions">
            <h3>
                Notes par séssions
            </h3>
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th style="width: 20%">Titre</th>
                    <th style="min-width: 20%">Date de début</th>
                    <th style="min-width: 20%">Connaissance du sujet</th>
                    <th style="min-width: 20%">Qualités pédagogiques</th>
                    <th style="min-width: 20%">Qualité des réponses</th>
                    <th style="min-width: 20%">Disponibilité</th>
                    <th style="min-width: 20%">Nombre de stagiaires</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let session of sessions" class="session-line"
                    uiSref="session-detail" [uiParams]="{ id: session.sessionId}">
                    <td style="user-select: none">
                        <a>
                            {{session.trainingTitle}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.sessionStartDate | formatdatepipe}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.trainerSubjectKnowledge}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.trainerPedagogicalQuality}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.trainerAnswerQuality}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.trainerAvailability}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.evaluations.length}}
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/detail/evaluation/evaluation.component.html